<template>
  <v-flex xs12 lg4>
    <v-sheet
      elevation="0"
      :class="{
        'file-chip': true,
        empty: !uploaded,
        filled: uploaded,
        dragging,
        selectMode
      }"
      color="primary lighten-1"
      ref="dragdrop"
      @dragover="editMode ? dragOver($event) : null"
      @dragleave="editMode ? dragLeave($event) : null"
      @drop="editMode ? drop($event) : null"
    >
      <div style="height: 30px">
        <v-menu offset-y v-if="!selectMode" z-index="9999">
          <template v-slot:activator="{ on }">
            <div class="d-flex align-center" style="float: right; height: 100%">
              <v-progress-circular
                size="18"
                class="mr-2 pt-1 pb-1"
                indeterminate
                color="accent"
                v-if="dlLoading"
              />
              <v-icon
                size="18"
                class="mr-2 pt-1 pb-1"
                color="primary"
                v-if="!dlLoading && uploaded"
                @click.stop="downloadDoc()"
                >cloud_download</v-icon
              >
              <span
                class="mr-3 pt-1 pb-1"
                v-if="uploaded"
                @click.stop="downloadDoc()"
                >{{ document.driveId.length }}
                {{ count != null ? ` / ${count}` : "" }}</span
              >
              <v-progress-circular
                size="18"
                class="pt-1 pb-1"
                v-if="!uploaded && loading"
                indeterminate
                color="accent"
              />

              <v-icon
                size="18"
                class="pt-1 pb-1"
                color="primary"
                v-if="editMode && !uploaded && !loading"
                @click.stop="uploadPopup()"
                >cloud_upload</v-icon
              >
              <v-progress-circular
                size="18"
                class="pt-1 pb-1"
                v-if="uploaded && loading"
                indeterminate
                color="accent"
              />
              <v-icon
                size="18"
                class="pt-1 pb-1"
                color="primary"
                v-if="editMode && uploaded && !loading"
                @click.stop="uploadPopup()"
                >add</v-icon
              >
              <v-icon
                size="17"
                v-on="on"
                class="pl-3 pt-1 pb-1 pr-1"
                color="primary"
                @click.stop
                >menu</v-icon
              >
            </div>
          </template>
          <v-list>
            <v-list-tile v-if="uploaded" @click.stop="downloadDoc()">
              <v-list-tile-action
                ><v-icon>cloud_download</v-icon></v-list-tile-action
              >
              <v-list-tile-title>Télécharger</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="uploaded" @click.stop="downloadDoc('zip')">
              <v-list-tile-action><v-icon>archive</v-icon></v-list-tile-action>
              <v-list-tile-title>Télécharger (ZIP)</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="template" @click.stop="downloadTemplate">
              <v-list-tile-action
                ><v-icon>cloud_download</v-icon></v-list-tile-action
              >
              <v-list-tile-title>Télécharger le modèle</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="remove(true)" v-if="editMode && uploaded">
              <v-list-tile-action
                ><a :href="href"><v-icon>clear</v-icon></a></v-list-tile-action
              >
              <v-list-tile-title>Effacer le fichier</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="remove(false)" v-if="editMode">
              <v-list-tile-action
                ><a :href="href"><v-icon>clear</v-icon></a></v-list-tile-action
              >
              <v-list-tile-title>Enlever le document</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <div class="d-flex align-center" style="height: 100%">
          <v-checkbox
            v-if="selectMode && uploaded && !encrypted"
            v-model="selected"
            @change="$emit('toggleSelect', document)"
            style="flex: initial !important"
            :label="label"
          ></v-checkbox>
          <div
            @click="show"
            v-else
            style="height: 100%; display: flex; align-items: center"
          >
            <v-icon
              size="18"
              class="pt-1 pb-1"
              v-if="encrypted"
              style="color: red !important"
              >lock</v-icon
            >
            {{ label }}
          </div>
        </div>
        <input
          type="file"
          id="fileInput"
          ref="fileInput"
          style="display: none"
          accept="image/png,image/jpeg,application/pdf"
          @change="uploadFilesFromPopup"
          multiple
          :readonly="!editMode"
          :disabled="!editMode"
        />
      </div>
    </v-sheet>
  </v-flex>
</template>

<script>
import { fetchHil } from "../../utils";
import { DOCUMENT_TYPES } from "../../data/DefaultSettings";
import { mapActions } from "vuex";
import { downloadFile } from "../../../../webapp-commons/functions";

export default {
  name: "DocumentChip",
  props: ["document", "selectMode", "project", "editMode"],
  data: function() {
    return {
      loading: false,
      dragging: false,
      selected: false,
      dlLoading: false
    };
  },
  computed: {
    label() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].text;
      } else {
        return this.document.title;
      }
    },
    count() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].count || null;
      } else {
        return null;
      }
    },
    uploaded() {
      return this.document.driveId.length > 0;
    },
    permanent() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].permanent;
      } else {
        return false;
      }
    },
    href() {
      return !this.uploaded
        ? null
        : `${process.env.VUE_APP_BASEURL}/documents/for/${this.document.leaseId}/document/${this.document._id}`;
    },
    template() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].templated;
      } else {
        return null;
      }
    },
    encrypted() {
      if (!this.document.meta || !this.document.meta.encrypted) {
        return false;
      }
      for (const docId of this.document.driveId) {
        if (this.document.meta.encrypted[docId]) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    ...mapActions("ui", ["showPDF"]),

    dragOver(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dragging = true;
    },
    dragLeave() {
      this.dragging = false;
    },
    drop(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dragging = false;
      this.uploadFiles(e.dataTransfer);
    },
    uploadPopup() {
      this.$refs.fileInput.click();
    },
    async downloadDoc(format = "pdf") {
      if (!this.uploaded) {
        return;
      }
      this.dlLoading = true;

      try {
        const data = await fetchHil(
          `/documents/for/${this.document.leaseId}/document/${this.document._id}?format=${format}`
        );
        await downloadFile(data);
      } catch (e) {
      } finally {
        this.dlLoading = false;
      }
    },
    async show() {
      if (!this.uploaded) {
        return;
      }
      this.showPDF({
        data: null
      });

      const headers = headers || new Headers();
      const token = localStorage.getItem("hil_token");
      if (token != null) {
        headers.append("Authorization", token);
      }

      this.showPDF({
        data: {
          url:
            process.env.VUE_APP_BASEURL +
            `/documents/for/${this.document.leaseId}/document/${this.document._id}`,
          httpHeaders: {
            Authorization: token
          }
        },
        loading: false
      });
    },
    async downloadTemplate() {
      const data = await fetchHil(
        `/documents/for/${this.document.leaseId}/document/templated/${this.template}`
      );
      await downloadFile(data);
    },
    async uploadFilesFromPopup(e) {
      this.uploadFiles(e.target);
    },
    async uploadFiles(dt) {
      this.loading = true;
      try {
        for (let f of dt.files) {
          if (!f.type.startsWith("image/") && f.type !== "application/pdf") {
            alert("Seul les images et les pdf sont acceptés");
            continue;
          }
          const formData = new FormData();
          formData.append("file", f);
          const leaseId = this.project._id;
          await fetchHil(
            `/documents/for/${leaseId}/document/${this.document._id}/upload`,
            {
              method: "PUT",
              body: formData
            }
          );
          this.$emit("change");
        }
      } finally {
        this.loading = false;
      }
    },
    async remove(fileOnly) {
      const leaseId = this.project._id;
      await fetchHil(
        `/documents/for/${leaseId}/document/${this.document._id}?fileOnly=${fileOnly}`,
        { method: "DELETE" }
      );
      this.$emit("change");
    }
  }
};
</script>

<style scoped>
.file-chip {
  padding: 5px 10px;
  margin-right: 10px;
  color: white !important;
  cursor: pointer;
}
.file-chip.filled .v-icon {
  color: white !important;
}
.file-chip.filled.selectMode {
  opacity: 1;
  background: white !important;
  color: black !important;
  border-width: 2px !important;
  border-style: solid !important;
}
.file-chip.empty {
  background-color: white !important;
  color: black !important;
  border-width: 2px !important;
  border-style: solid !important;
}
.file-chip.empty.selectMode {
  opacity: 0.4;
}
.file-chip.empty.dragging,
.file-chip.dragging {
  background-color: #ff7c5d !important;
  color: white !important;
  border: 0 !important;
}
.file-chip.dragging .v-icon {
  display: none;
}
</style>
